import { FieldArray } from 'formik'
import { MdAdd } from 'react-icons/md'

import type { FormValues } from '..'
import type { FieldArrayRenderProps } from 'formik'
import type { ReactElement } from 'react'

import PropertiesField from '../../../AssetsListing/shared/PropertiesField'

import Button from '~/components/Buttons/Button'

import './styles.scss'

interface Props {
  formValues: FormValues
  modalId: string
  selectOptions: IOption[]
}

const PropertiesModalForm = ({ formValues, modalId, selectOptions }: Props): ReactElement => {
  const handleAddClick = (arrayHelpers: FieldArrayRenderProps) => {
    arrayHelpers.push({ key: null, value: '' })
  }

  const handleDeleteClick = (arrayHelpers: FieldArrayRenderProps, index: number) => {
    if (formValues.properties.length > 1) {
      arrayHelpers.remove(index)
    }
  }

  return (
    <FieldArray
      name="properties"
      render={(arrayHelpers) => (
        <div className="properties-modal-form-component">
          <div className="title">
            <div>Add new properties</div>
            <Button color="primary" onClick={() => handleAddClick(arrayHelpers)} type="button">
              <MdAdd color="#fff" size={16} />
            </Button>
          </div>
          {formValues.properties.map(({ key }, index) => (
            <PropertiesField
              index={index}
              key={`${key}-${index}`}
              modalId={modalId}
              onDelete={() => handleDeleteClick(arrayHelpers, index)}
              selectOptions={selectOptions}
            />
          ))}
        </div>
      )}
    />
  )
}

export default PropertiesModalForm
